import * as React from 'react';
import { IFilterListText } from 'services/containers/containers-service';
import { Filters } from 'components';
import i18n from 'i18next';

const CheckBoxFilterComponent = Filters['list_text'];

export interface IOneCheckboxFilterItem {
    filter: IFilterListText;
    onFilterChange: (filter: IOneCheckboxFilterItem['filter']) => any;
}

/* eslint-disable arrow-body-style */
/**
 * Функция получает "позитивные" значения из фильтра `filter`.
 * Позитивными значениями считаются все значения кроме "Нет".
 */
const getPositiveValues = (filter: IFilterListText): IFilterListText['values'] => {
    return filter.values.filter(value => value.toLowerCase() !== i18n.t('нет'));
};
/* eslint-enable arrow-body-style */

/**
 * Изменяет фильтр таким образом чтоб из него можно было отрендерить стандартным компонентом
 * фильтра с чекбоксами просто 1 чекбокс.
 * Вместо:
 *      Наличие водоснабжения
 *          ✔ Да
 *          ✔ Нет
 *          ✔ Есть возможность подключения
 * Отрендерить просто
 *      ✔ Наличие водоснабжения
 */
const forgeOneCheckboxFilter = (filter: IFilterListText): IFilterListText => ({
    ...filter,
    name: '',
    value: (filter.value !== null && filter.value.length) ? [ filter.name ] : null,
    values: [ filter.name ]
});

export const OneCheckboxFilterItem = ({
    filter,
    onFilterChange
}: IOneCheckboxFilterItem) => (
    <CheckBoxFilterComponent
        filter={forgeOneCheckboxFilter(filter)}
        className='one-checkbox-filter'
        onFilterChange={(filter_id, value: IFilterListText['values']) => {
            let new_filter: IFilterListText;
            // Если мы получили 1 значение (оно будет равно названию фильтра), то значит что фильтр
            // включили, а значит нужно подставить все "положительные" значения фильтра.
            if (value?.length === 1) {
                new_filter = {
                    ...filter,
                    value: getPositiveValues(filter)
                };
            } else {
                // Если мы получили пустой массив, то значит что фильтр выключили и надо просто сбросить
                // значения
                new_filter = {
                    ...filter,
                    value: null
                };
            }
            onFilterChange(new_filter);
        }}
    />
);
